import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const CollectionPreviewTooltipContentFragment = graphql(
  `
    fragment CollectionPreviewTooltipContent on CollectionIdentifier {
      slug
      ... on Collection {
        ...CollectionLockup
      }
    }
  `,
  [CollectionLockupFragment],
)
